import axios from "./axios"
export const refreshToken = async () => {
    const response = await axios.get('users/refresh', { withCredentials: true })
    return response.data
}
